import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export class LoginPasswordResetRequestForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: true,
    };

    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.newPasswordResetRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts
    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the email input field with a small delay to ensure modal is rendered
    setTimeout(() => {
      if (this.newPasswordResetRef.current) {
        this.newPasswordResetRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  componentWillUnmount() {
    this.setState({ isMounted: false }); // Set isMounted to false when the component unmounts
    document.removeEventListener('keydown', this.keydownHandler);
  }

  async keydownHandler(e) {
    if (e.keyCode === 13) {
      this.props.handlePasswordResetRequest();
    }
    if (e.keyCode === 27) {
      this.handleCancel();
    }
  }

  handleCancel = () => {
    this.props.handleResetModel();
    this.props.setForgotPasswordModal(false);
  };

  render() {
    return (
      <Modal
        isOpen={this.props.forgotPasswordModal}
        toggle={this.props.setForgotPasswordModal}
        style={{ width: '500px', height: '300px' }}
        backdrop="static"
      >
        <ModalHeader>Reset Password</ModalHeader>
        <ModalBody>
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <Alert
                color={this.props.alert.color}
                isOpen={this.props.alert.isOpen}
              >
                {this.props.alert.message}
              </Alert>
            </Col>
          </Row>

          <input
            type="text"
            name="reset_email"
            className="form-control"
            id="reset_email"
            ref={this.newPasswordResetRef}
            value={this.props.reset_email}
            onChange={this.props.handleChange}
            placeholder="Enter your email"
            autoComplete="off"
          />
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.handlePasswordResetRequest}
          >
            Submit
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={this.handleCancel}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
